<script lang="ts" setup>
import { computed, ref, watch } from "vue";

const props = withDefaults(
  defineProps<{
    show: boolean;
    textList: string[];
    timeoutSec: number;
    fallbackText: string; // 到达时间后显示的文本（用来兜底）
  }>(),
  {
    show: false,
    textList: () => [],
    timeoutSec: 10,
    fallbackText: "",
  }
);
const emit = defineEmits<{
  (e: "update:show", value: boolean): void;
  (e: "update:progress", value: number): void;
  (e: "update:text", value: string): void;
}>();

const progress = ref(0);
const restSec = ref(props.timeoutSec);
const displayText = computed(() => {
  if (props.textList.length === 0) {
    return "";
  } else if (props.textList.length === 1) {
    return props.textList[0];
  } else {
    const textIdx = Math.floor(
      (props.textList.length * (props.timeoutSec - restSec.value)) /
        props.timeoutSec
    );
    return props.textList[Math.min(textIdx, props.textList.length - 1)];
  }
});
let intervalId = 0;

watch(
  () => props.show,
  (show) => {
    if (show) {
      reset();
      // 2. 显示时启动定时器
      intervalId = window.setInterval(() => {
        if (restSec.value <= 0) {
          clearInterval(intervalId);
          return;
        }
        restSec.value -= 1;
        progress.value = Math.floor(
          ((props.timeoutSec - restSec.value) / props.timeoutSec) * 100
        );
      }, 1000);
    }
  }
);

function reset() {
  clearInterval(intervalId);
  restSec.value = props.timeoutSec;
  progress.value = 0;
}

const finish = () => {
  if (progress.value < 100) {
    progress.value = 100;
  }
  emit("update:show", false);
};

export interface RadialProgressPopupInstance {
  finish: typeof finish;
}

defineExpose<RadialProgressPopupInstance>({ finish });
</script>
<template>
  <van-toast :show="show" forbid-click teleport="body">
    <template #message>
      <div class="flex flex-col gap-2 items-center justify-center w-32 h-32">
        <template v-if="restSec > 0">
          <div
            :style="`--value: ${progress}`"
            class="radial-progress"
            role="progressbar"
          >
            {{ progress }}%
          </div>
          <div v-if="displayText" class="text-center">{{ displayText }}</div>
        </template>
        <template v-else>
          <div class="w-20 h-20 flex items-center justify-center">
            <div class="loading loading-ring loading-lg" />
          </div>
          <div v-if="fallbackText" class="text-center">{{ fallbackText }}</div>
        </template>
      </div>
    </template>
  </van-toast>
</template>
